import { client } from "../libs/client";

export const registerUser = async (data) => {
  return await client.post("/user/register", data);
};

export const loginUser = async (data) => {
  return await client.post("/user/login", data);
};

export const changePassword = async (data) => {
  return await client.post("/user/change-password", data);
};

export const refreshToken = async () => {
  return await client.get("/user/refresh-token");
};

export const forgotPassword = async (data) => {
  return await client.post("/user/forgot-password", data);
};

export const validateResetToken = async (data) => {
  return await client.post("/user/validate-reset-token", data);
};

export const resetPassword = async (data) => {
  return await client.post("/user/reset-password", data);
};

export const requestAccountDeletion = async () => {
  return await client.post("/user/request-account-deletion");
};

export const cancelAccountDeletion = async (token) => {
  return await client.post(`/user/cancel-deletion/${token}`);
};

export const resendVerificationEmail = async () => {
  return await client.post("/user/resend-verification-email");
};

export const verifyEmail = async (data) => {
  return await client.post("/user/verify-email", data);
};

export const requestEmailVerification = async (email = null) => {
  const data = email ? { email } : {};
  return await client.post("/user/request-email-verification", data);
};

export const changeEmail = async (data) => {
  return await client.post("/user/change-email", data);
};
